module.exports = __webpack_public_path__ + "static/media/Vuilniswagen.d308653b.mp3";